export class CreditCardModel
{
  isValid: boolean;
    public name:string = "";
    public number:string = "";
    public expiry:string ="";
    public cvc:number = 0;
}

export class PersonalDataModel
{
    public name:string = "";
    public document:string = "";
    public address:string ="";
    public city:string ="";
    public state:string ="";
    public zipcode:string ="";
    public phone:string ="";
}